import { Outlet } from 'react-router-dom';
import { TicketingProvider, useTicketing } from '../../contexts/TicketingContext';
import { ReassignDrawer } from '../../components/ReassignDrawer/ReassignDrawer';
import { AppSnackbar } from '../../components/ui';
import { useTheme } from '../../contexts/ThemeContext';
import './Workbench.css';

function TicketingLayoutContent() {
  const { theme } = useTheme();
  const {
    techs,
    snackbar,
    reassignDrawerOpen,
    ticketToReassign,
    handleReassignSubmit,
    handleError,
    closeSnackbar,
    closeReassignDrawer,
  } = useTicketing();

  return (
    <div className="ticketing-layout" data-theme={theme}>
      <Outlet />

      <ReassignDrawer
        isOpen={reassignDrawerOpen}
        onClose={closeReassignDrawer}
        ticket={ticketToReassign}
        technicians={techs}
        onReassign={handleReassignSubmit}
        onError={handleError}
      />

      <AppSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        autoHideDuration={6000}
        onClose={closeSnackbar}
      />
    </div>
  );
}

export function TicketingLayout() {
  return (
    <TicketingProvider>
      <TicketingLayoutContent />
    </TicketingProvider>
  );
}
